module.exports = __webpack_public_path__ + "static/media/end_report_ie.7e25bca4.png";